import { Injectable } from '@angular/core';
import { DiagnoseTemplateList, DiagnoseTemplate } from '../business-entities/diagnose-template-modal';
import { GenericResponse } from '../business-entities/generic-response';
import { DiagnoseTemplateDataService } from '../data-services/diagnose-template-data.service';


@Injectable({
    providedIn: 'root'
})

export class DiagnoseTemplateBusinessService {
    constructor(private service: DiagnoseTemplateDataService) {
    }
    diagnoseTemplateId:number
    diagnoseTemplateList: DiagnoseTemplateList[];
    diagnoseTemplate:DiagnoseTemplate

    async getDiagnoseTemplateList(model: any): Promise<Array<DiagnoseTemplateList>> {
        await this.service
            .getDiagnoseTemplateList(model)
            .then(
                (res: GenericResponse<Array<DiagnoseTemplateList>>) => {
                    this.diagnoseTemplateList = res.responseObject;
                }
            );
        return this.diagnoseTemplateList;
    }

    addDiagnoseTemplate(model:any):Promise<any>{
        return this.service.addDiagnoseTemplate(model);
    }
    async getDiagnoseTemplateById(Id: number): Promise<DiagnoseTemplate> {
        await this.service
            .getDiagnoseTemplateById(Id)
            .then(
                (res: GenericResponse<DiagnoseTemplate>) => {
                    this.diagnoseTemplate = res.responseObject;
                }
            );
        return this.diagnoseTemplate;
    }

    editDiagnoseTemplate(model:any):Promise<any>{
        return this.service.editDiagnoseTemplate(model);
    }

    deleteDiagnoseTemplate(id: number): Promise<GenericResponse<any>> {
        return this.service.deleteDiagnoseTemplate(id);
    }

}
